module.exports = __webpack_public_path__ + "static/media/Safety-and-security.1c3a0f13.png";